import React, { memo } from 'react';
import { QuotationHeader } from './QuotationHeader';
import { QuotationTravellerInfo } from './QuotationTravellerInfo';
import { QuotationItinerary } from './QuotationItinerary';
import { QuotationPricing } from './QuotationPricing';
import { QuotationTotals } from './QuotationTotals';
import { QuotationTerms } from './QuotationTerms';
export function Quotation() {
  const companyInfo = {
    name: 'MyTourix Travel Management',
    address: ['123 Orchard Road, #12-34', 'Singapore 238858'],
    phone: '+65 6789 1234',
    email: 'quotes@mytourix.com',
    uen: '201234567G'
  };
  const quotationInfo = {
    number: 'QT-2025-00089',
    date: '20 January 2025',
    validUntil: '20 February 2025',
    currency: 'SGD',
    bookingReference: 'BKG-2025-TR-889',
    salesOwner: 'Sarah Chen'
  };
  const travellerInfo = {
    travellers: ['ANDERSON / JAMES MR', 'ANDERSON / EMILY MS'],
    travelDates: '15 March 2025 - 22 March 2025',
    totalNights: 7,
    destinations: ['Tokyo', 'Kyoto', 'Osaka'],
    paxCount: '2 Adults'
  };
  const itinerary = [{
    day: 1,
    title: 'Arrival in Tokyo',
    description: 'Arrive at Narita International Airport. Private transfer to your hotel in Shibuya. Check-in and rest after your flight. Evening at leisure to explore the vibrant Shibuya district.',
    activities: ['Private airport transfer', 'Hotel check-in at Park Hyatt Tokyo', 'Welcome dinner at hotel restaurant']
  }, {
    day: 2,
    title: 'Tokyo City Exploration',
    description: "Full day guided tour of Tokyo's iconic landmarks. Visit the historic Senso-ji Temple, explore the bustling Tsukiji Outer Market, and experience the serene Meiji Shrine. Afternoon shopping in Harajuku and Omotesando.",
    activities: ['Senso-ji Temple visit with guide', 'Tsukiji Outer Market food tour', 'Meiji Shrine and Yoyogi Park', 'Shopping in Harajuku district', 'Dinner at traditional izakaya']
  }, {
    day: 3,
    title: 'Mount Fuji Day Trip',
    description: 'Scenic day trip to Mount Fuji and Hakone region. Visit the 5th Station of Mount Fuji (weather permitting), cruise on Lake Ashi, and ride the Hakone Ropeway for spectacular views. Return to Tokyo in the evening.',
    activities: ['Private coach to Mount Fuji', 'Mount Fuji 5th Station visit', 'Lake Ashi cruise', 'Hakone Ropeway experience', 'Traditional kaiseki lunch']
  }, {
    day: 4,
    title: 'Tokyo to Kyoto via Bullet Train',
    description: 'Morning at leisure for last-minute shopping. Check out and transfer to Tokyo Station. Board the Shinkansen bullet train to Kyoto. Check-in to your traditional ryokan. Evening stroll through Gion district.',
    activities: ['Shinkansen bullet train experience (Reserved seats)', 'Check-in at traditional ryokan', 'Gion district evening walk', 'Traditional kaiseki dinner at ryokan']
  }, {
    day: 5,
    title: 'Kyoto Temples and Gardens',
    description: "Full day exploring Kyoto's UNESCO World Heritage sites. Visit the golden Kinkaku-ji Temple, walk through the thousands of torii gates at Fushimi Inari Shrine, and experience the zen gardens of Ryoan-ji Temple.",
    activities: ['Kinkaku-ji (Golden Pavilion) visit', 'Fushimi Inari Shrine hike', 'Ryoan-ji Temple zen garden', 'Arashiyama Bamboo Grove', 'Traditional tea ceremony experience']
  }, {
    day: 6,
    title: 'Kyoto to Osaka',
    description: 'Morning visit to Nara to see the famous deer park and Todai-ji Temple. Afternoon transfer to Osaka. Check-in to hotel and evening exploration of Dotonbori district with its famous street food and neon lights.',
    activities: ['Nara Park and deer feeding', 'Todai-ji Temple Great Buddha', 'Transfer to Osaka', 'Dotonbori district food tour', 'Osaka Castle illumination (evening)']
  }, {
    day: 7,
    title: 'Departure from Osaka',
    description: 'Final morning at leisure for shopping or exploring. Check out from hotel. Private transfer to Kansai International Airport for your departure flight. End of tour with wonderful memories of Japan.',
    activities: ['Hotel check-out', 'Last-minute shopping at Shinsaibashi', 'Private airport transfer', 'Departure assistance']
  }];
  const pricingItems = [{
    description: 'Accommodation',
    details: [{
      label: 'Destination',
      value: 'Tokyo, Japan'
    }, {
      label: 'Hotel Name',
      value: 'Park Hyatt Tokyo'
    }, {
      label: 'Check-In Date',
      value: '15 MAR 2025'
    }, {
      label: 'Check-Out Date',
      value: '18 MAR 2025'
    }, {
      label: 'No. of Nights',
      value: '3'
    }, {
      label: 'Room Type',
      value: 'Deluxe Room'
    }, {
      label: 'Room Category',
      value: 'Park View King'
    }, {
      label: 'Traveller(s)',
      value: 'ANDERSON / JAMES MR, ANDERSON / EMILY MS'
    }],
    unitPrice: 450.0,
    quantity: 3,
    tax: 94.5,
    amount: 1444.5
  }, {
    description: 'Accommodation',
    details: [{
      label: 'Destination',
      value: 'Kyoto, Japan'
    }, {
      label: 'Hotel Name',
      value: 'Traditional Ryokan Yoshikawa'
    }, {
      label: 'Check-In Date',
      value: '18 MAR 2025'
    }, {
      label: 'Check-Out Date',
      value: '20 MAR 2025'
    }, {
      label: 'No. of Nights',
      value: '2'
    }, {
      label: 'Room Type',
      value: 'Japanese-style Room'
    }, {
      label: 'Room Category',
      value: 'Deluxe with Private Bath'
    }, {
      label: 'Traveller(s)',
      value: 'ANDERSON / JAMES MR, ANDERSON / EMILY MS'
    }],
    unitPrice: 380.0,
    quantity: 2,
    tax: 53.2,
    amount: 813.2
  }, {
    description: 'Accommodation',
    details: [{
      label: 'Destination',
      value: 'Osaka, Japan'
    }, {
      label: 'Hotel Name',
      value: 'Hilton Osaka'
    }, {
      label: 'Check-In Date',
      value: '20 MAR 2025'
    }, {
      label: 'Check-Out Date',
      value: '22 MAR 2025'
    }, {
      label: 'No. of Nights',
      value: '2'
    }, {
      label: 'Room Type',
      value: 'Executive Room'
    }, {
      label: 'Room Category',
      value: 'City View King'
    }, {
      label: 'Traveller(s)',
      value: 'ANDERSON / JAMES MR, ANDERSON / EMILY MS'
    }],
    unitPrice: 280.0,
    quantity: 2,
    tax: 39.2,
    amount: 599.2
  }, {
    description: 'Flight',
    details: [{
      label: 'Routing',
      value: 'SIN / NRT (Tokyo)'
    }, {
      label: 'Departure Date',
      value: '15 MAR 2025'
    }, {
      label: 'Arrival Date',
      value: '15 MAR 2025'
    }, {
      label: 'Flight No.',
      value: 'SQ 638'
    }, {
      label: 'Cabin Class',
      value: 'Y (Economy)'
    }, {
      label: 'Traveller(s)',
      value: 'ANDERSON / JAMES MR (ADT), ANDERSON / EMILY MS (ADT)'
    }],
    unitPrice: 650.0,
    quantity: 2,
    tax: 91.0,
    amount: 1391.0
  }, {
    description: 'Flight',
    details: [{
      label: 'Routing',
      value: 'KIX (Osaka) / SIN'
    }, {
      label: 'Departure Date',
      value: '22 MAR 2025'
    }, {
      label: 'Arrival Date',
      value: '22 MAR 2025'
    }, {
      label: 'Flight No.',
      value: 'SQ 623'
    }, {
      label: 'Cabin Class',
      value: 'Y (Economy)'
    }, {
      label: 'Traveller(s)',
      value: 'ANDERSON / JAMES MR (ADT), ANDERSON / EMILY MS (ADT)'
    }],
    unitPrice: 680.0,
    quantity: 2,
    tax: 95.2,
    amount: 1455.2
  }, {
    description: 'Transportation',
    details: [{
      label: 'Service Type',
      value: 'Private Airport Transfers'
    }, {
      label: 'Route',
      value: 'Narita Airport to Hotel (Arrival)'
    }, {
      label: 'Route',
      value: 'Hotel to Kansai Airport (Departure)'
    }, {
      label: 'Vehicle Type',
      value: 'Private Car with English-speaking driver'
    }, {
      label: 'Traveller(s)',
      value: 'ANDERSON / JAMES MR, ANDERSON / EMILY MS'
    }],
    unitPrice: 120.0,
    quantity: 2,
    tax: 16.8,
    amount: 256.8
  }, {
    description: 'Transportation',
    details: [{
      label: 'Service Type',
      value: 'Shinkansen Bullet Train'
    }, {
      label: 'Route',
      value: 'Tokyo to Kyoto'
    }, {
      label: 'Class',
      value: 'Reserved Seats (Ordinary Class)'
    }, {
      label: 'Traveller(s)',
      value: 'ANDERSON / JAMES MR, ANDERSON / EMILY MS'
    }],
    unitPrice: 140.0,
    quantity: 2,
    tax: 19.6,
    amount: 299.6
  }, {
    description: 'Tours & Activities',
    details: [{
      label: 'Tour Name',
      value: 'Full-Day Tokyo City Tour'
    }, {
      label: 'Includes',
      value: 'English-speaking guide, entrance fees, lunch'
    }, {
      label: 'Duration',
      value: '8 hours'
    }, {
      label: 'Traveller(s)',
      value: 'ANDERSON / JAMES MR, ANDERSON / EMILY MS'
    }],
    unitPrice: 180.0,
    quantity: 2,
    tax: 25.2,
    amount: 385.2
  }, {
    description: 'Tours & Activities',
    details: [{
      label: 'Tour Name',
      value: 'Mount Fuji and Hakone Day Trip'
    }, {
      label: 'Includes',
      value: 'Private coach, guide, Lake Ashi cruise, Hakone Ropeway, lunch'
    }, {
      label: 'Duration',
      value: '10 hours'
    }, {
      label: 'Traveller(s)',
      value: 'ANDERSON / JAMES MR, ANDERSON / EMILY MS'
    }],
    unitPrice: 220.0,
    quantity: 2,
    tax: 30.8,
    amount: 470.8
  }, {
    description: 'Tours & Activities',
    details: [{
      label: 'Tour Name',
      value: 'Kyoto Temples and Gardens Tour'
    }, {
      label: 'Includes',
      value: 'English-speaking guide, entrance fees, tea ceremony'
    }, {
      label: 'Duration',
      value: '8 hours'
    }, {
      label: 'Traveller(s)',
      value: 'ANDERSON / JAMES MR, ANDERSON / EMILY MS'
    }],
    unitPrice: 160.0,
    quantity: 2,
    tax: 22.4,
    amount: 342.4
  }, {
    description: 'Travel Insurance',
    details: [{
      label: 'Coverage Period',
      value: '15 MAR 2025 - 22 MAR 2025 (7 days)'
    }, {
      label: 'Coverage Amount',
      value: 'Up to SGD 100,000'
    }, {
      label: 'Includes',
      value: 'Medical expenses, trip cancellation, baggage loss'
    }, {
      label: 'Traveller(s)',
      value: 'ANDERSON / JAMES MR, ANDERSON / EMILY MS'
    }],
    unitPrice: 75.0,
    quantity: 2,
    tax: 10.5,
    amount: 160.5
  }];
  const totals = {
    subtotal: 7129.8,
    tax: 498.4,
    grandTotal: 7628.2,
    currency: 'SGD'
  };
  const termsAndConditions = `1. PAYMENT TERMS
   - 30% deposit required upon booking confirmation
   - Full payment due 30 days before departure
   - Payment accepted via bank transfer or credit card (2% surcharge applies)

2. CANCELLATION POLICY
   - More than 60 days before departure: 10% cancellation fee
   - 30-60 days before departure: 50% cancellation fee
   - Less than 30 days before departure: 100% cancellation fee (no refund)

3. BOOKING CONDITIONS
   - All rates are subject to availability at time of booking
   - Prices may change due to currency fluctuations or supplier rate changes
   - This quotation is valid for 30 days from the date of issue

4. TRAVEL DOCUMENTS
   - Valid passport required (minimum 6 months validity)
   - Visa requirements are the traveller's responsibility
   - Travel insurance is strongly recommended

5. FORCE MAJEURE
   - We are not liable for circumstances beyond our control
   - This includes natural disasters, strikes, or government restrictions`;
  const additionalNotes = `WHAT'S INCLUDED:
• All accommodation as specified (7 nights total)
• Round-trip economy flights (Singapore - Tokyo, Osaka - Singapore)
• Daily breakfast at all hotels
• Private airport transfers
• Shinkansen bullet train tickets (Tokyo to Kyoto)
• All guided tours with English-speaking guides
• Entrance fees to all attractions mentioned
• Selected meals as per itinerary
• Comprehensive travel insurance

WHAT'S NOT INCLUDED:
• Japan entry visa (if required)
• Lunches and dinners not specified in itinerary
• Personal expenses and shopping
• Tips and gratuities for guides and drivers
• Additional activities not mentioned in itinerary

SPECIAL NOTES:
• This is a private tour for 2 adults
• All tours include English-speaking guides
• Accommodation can be upgraded upon request
• Itinerary can be customized to your preferences
• Cherry blossom season (mid-March) - expect crowds at popular sites

For any questions or modifications to this quotation, please contact Sarah Chen at +65 9123 4567 or sarah.chen@mytourix.com`;
  const currentDate = new Date().toLocaleString('en-SG', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
  return <div className="h-full overflow-auto bg-gradient-to-br from-neutral-50 to-neutral-100 p-6" data-id="element-876">
      {/* Note: Quotation is multi-page by nature, so we use scrollable container instead of fixed height */}
      <div className="w-[210mm] mx-auto bg-white shadow-lg rounded-xl p-8" data-id="element-877">
        <QuotationHeader company={companyInfo} quotation={quotationInfo} data-id="element-878" />
        <QuotationTravellerInfo {...travellerInfo} data-id="element-879" />
        <QuotationItinerary days={itinerary} data-id="element-880" />
        <QuotationPricing items={pricingItems} data-id="element-881" />
        <QuotationTotals {...totals} data-id="element-882" />
        <QuotationTerms termsAndConditions={termsAndConditions} additionalNotes={additionalNotes} data-id="element-883" />

        {/* Footer */}
        <div className="pt-5 border-t border-neutral-200 text-center space-y-1" data-id="element-884">
          <p className="text-xs text-neutral-500" data-id="element-885">
            Generated by system on {currentDate}
          </p>
          <p className="text-xs text-neutral-500 italic" data-id="element-886">
            This is a computer-generated document. No signature is required.
          </p>
        </div>
      </div>
    </div>;
}